'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaEjectOutline = function TiMediaEjectOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 35h-13.4c-2.7 0-5-2.2-5-5s2.3-5 5-5h13.4c2.7 0 5 2.2 5 5s-2.3 5-5 5z m-13.4-6.7c-0.9 0-1.6 0.8-1.6 1.7s0.7 1.7 1.6 1.7h13.4c0.9 0 1.6-0.8 1.6-1.7s-0.7-1.7-1.6-1.7h-13.4z m6.7-16.9l8.3 8.5 0 0.1-16.6 0c0 0 0.1-0.1 0.1-0.1l8.2-8.5z m0-4.7s-6.4 6.6-10.7 11c-0.6 0.6-1 1.4-1 2.3 0 1.8 1.5 3.3 3.4 3.3h16.6c1.9 0 3.4-1.5 3.4-3.3 0-0.9-0.4-1.7-1-2.3l-10.7-11z' })
        )
    );
};

exports.default = TiMediaEjectOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-eject-outline.js
// module id = 3651
// module chunks = 0